import { saveAs } from 'file-saver';
import { toast } from 'react-toastify';

import { authorizedFetch } from './api';
import { ApiError } from './ApiError';

async function request(url: string, config?: RequestInit): Promise<Blob> {
  const response = await authorizedFetch(url, config);
  if (!response.ok) {
    throw new ApiError(response.status, response.statusText);
  }
  return await response.blob();
}

const pdf = {
  downloadPDFAsync: async <T>(url: string, name: string, body: T | null = null) => {
    try {
      const blob =
        body == null ? await request(url) : await request(url, { method: 'POST', body: JSON.stringify(body) });
      saveAs(blob, `${name}.pdf`);
    } catch (error) {
      let errorMessage = '';
      if (error instanceof ApiError) {
        errorMessage = error.message;
      }
      toast.error(`Error downloading PDF: ${errorMessage ?? error}`, {
        position: 'top-right',
        toastId: 'PDFerror',
        autoClose: false,
      });
      throw error;
    }
  },
  previewHTMLAsync: async (url: string, callback?: () => void) => {
    try {
      const blob = await request(url);
      const href = globalThis.URL.createObjectURL(blob);

      const iframe = document.createElement('iframe');
      document.body.appendChild(iframe);
      iframe.src = href;
      iframe.onload = () => {
        setTimeout(() => {
          iframe.focus();
          iframe.contentWindow?.print();
          callback?.();
        }, 1);
      };
    } catch (error) {
      let errorMessage = '';
      if (error instanceof ApiError) {
        errorMessage = error.message;
      }
      toast.error(`Error previewing PDF: ${errorMessage ?? error}`, {
        position: 'top-right',
        toastId: 'PDFerror',
        autoClose: false,
      });
      throw error;
    }
  },
};

export default pdf;
